import { hillo } from 'hillo'

export async function printDailyCardTerminal (info) {
  return (await hillo.post('Complex.php?op=printPaymentBon', {
    ...info
  }))
}
